import React from "react";
import styled from "styled-components";
import { isMobile } from "@kubera/common";

import Spinner from "components/loader/Spinner";
import { addKeyboardEventListener, removeKeyboardEventListener } from "utilities/EventManager";

const isMobileDevice = isMobile();

const Button = styled.button`
  position: relative;
  width: fit-content;
  height: 2.75rem;
  min-width: ${props => (isMobileDevice ? "7.875rem" : "9.6875rem")};
  background-color: ${props =>
    props.isDestructive === true
      ? props.isDisabled
        ? props.theme.primaryButtonDestructiveDisabledBackgroundColor
        : props.theme.primaryButtonDestructiveBackgroundColor
      : props.isLoading === true || props.isDisabled === true
      ? props.theme.primaryButtonLoadingBackgroundColor
      : props.theme.primaryButtonBackgroundColor};
  font-size: 0.75rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props =>
    props.isDestructive === true
      ? props.isDisabled
        ? props.theme.primaryButtonDestructiveDisabledColor
        : props.theme.primaryButtonDestructiveColor
      : props.isDisabled === true
      ? props.theme.primaryButtonDisabledColor
      : props.theme.primaryButtonColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  cursor: ${props => (props.isDisabled ? "auto" : "pointer")};
  white-space: pre;
`;

const ButtonSpinner = styled(Spinner)`
  position: absolute;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.0625rem;

  ${({ loaderCss }) => loaderCss}
`;

const HiddenTitle = styled.span`
  visibility: hidden;
`;

class PrimaryButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    if (!this.props.enableEnterKey === false) {
      addKeyboardEventListener(this.handleKeyDown);
    }
  }

  componentWillUnmount() {
    removeKeyboardEventListener(this.handleKeyDown, true);
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.handleClick(e);
      e.preventDefault();
    }
  }

  handleClick(e) {
    if (this.props.isLoading === true || this.props.isDisabled === true) {
      return;
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    const { className, title, isLoading, isDisabled, isDestructive, onClick, loaderCss, ...other } = this.props;

    return (
      <Button
        className={className}
        {...other}
        tabIndex={"0"}
        onClick={this.handleClick}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isDestructive={isDestructive}
      >
        {isLoading === true ? (
          <>
            <ButtonSpinner loaderCss={loaderCss} />
            <HiddenTitle>{title}</HiddenTitle>
          </>
        ) : (
          title
        )}
      </Button>
    );
  }
}

export default PrimaryButton;
